import { MeasureCardHeaderLabel } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/MeasureCard/MeasureCardHeaderLabel";
import { MeasureChanges } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/MeasureCard/MeasureChanges";
import { PlanEventInformation } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/types";
import { FC } from "react";
import {
  Button,
  DialogCloseTrigger,
  DialogRoot,
  DialogTrigger,
  DropsDialogContent,
  Flex,
  StaticCard,
  Text,
} from "shared/components/Spor";
import { useThemeSemantic } from "shared/theme/themeSemantic";
import { formatMeasureCardDateTimeString } from "shared/utils/dateTimeUtils";
import { Semantics } from "shared/utils/semantics";

type RecentlyUpdatedDialogProps = {
  measure: PlanEventInformation;
  previousMeasure: PlanEventInformation;
  semantics: Semantics;
  acknowledgeLatestVersion: () => void;
};

export const RecentlyUpdatedDialog: FC<RecentlyUpdatedDialogProps> = ({
  measure: { information, internalMessages },
  previousMeasure,
  semantics,
  acknowledgeLatestVersion,
}) => {
  const theme = useThemeSemantic(semantics);

  return (
    <DialogRoot placement="center">
      <DialogTrigger asChild>
        <Button variant="tertiary" size="xs" semantic="warning" type="button">
          Se endring
        </Button>
      </DialogTrigger>

      <DropsDialogContent semantics="warning">
        <Flex direction="column" m={4} gap={1}>
          <Text variant="md-lg" fontWeight="bold">
            Endringer på hendelse
          </Text>
          <MeasureCardHeaderLabel information={information} />
          <Text>
            Sist oppdatert:{" "}
            {formatMeasureCardDateTimeString(information.updatedAt)}
          </Text>
          <DialogCloseTrigger />
        </Flex>

        <StaticCard
          backgroundColor={theme.colorWarningFillPulse}
          mx={1}
          p={3}
          display="flex"
          flexFlow="column nowrap"
          gap={3}
        >
          <MeasureChanges
            currentInformation={information}
            previousInformation={previousMeasure.information}
            currentInternalMessages={internalMessages}
            previousInternalMessages={previousMeasure.internalMessages}
          />
        </StaticCard>

        <Flex p={4} justifyContent="space-between">
          <DialogTrigger asChild>
            <Button type="button" variant="ghost" size="sm">
              Avbryt
            </Button>
          </DialogTrigger>

          <Button
            semantic="warning"
            type="button"
            variant="primary"
            size="sm"
            onClick={() => acknowledgeLatestVersion()}
          >
            Bekreft sett
          </Button>
        </Flex>
      </DropsDialogContent>
    </DialogRoot>
  );
};
